import { Book, Chapter } from '../../types';
import { ChapterNavigation } from '../chapter-navigation/chapter-navigation';
import { useSettings } from '../../contexts/settings-context';
import { useRef } from 'preact/hooks';
import { useTextToSpeech } from '../../hooks/use-text-to-speech';
import './content.css';
import './tts-highlight.css';

interface ContentProps {
  chapter: Chapter;
  book: Book;
  prevChapter?: Chapter;
  nextChapter?: Chapter;
  isPlaying: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
}

export const Content = ({
  chapter,
  book,
  prevChapter,
  nextChapter,
  isPlaying,
  setIsPlaying,
}: ContentProps) => {
  const { settings } = useSettings();
  const contentRef = useRef<HTMLDivElement>(null);

  // Use the text-to-speech hook
  useTextToSpeech({
    isPlaying,
    setIsPlaying,
    contentRef,
    chapter,
    nextChapter,
    book,
    ttsSettings: {
      ttsRate: settings.ttsRate as any,
      ttsVoice: settings.ttsVoice,
    },
  });

  return (
    <div
      className={`content text-size-${
        settings.textSizeIndex
      } font-${settings.fontFamily.replace(/,.*$/, '').toLowerCase()}${
        settings.firstLineIndent ? ' first-line-indent' : ''
      }`}
    >
      <p>
        <em>
          <a href={`/f/${book.permalink}`}>{book.title}</a>
        </em>
      </p>
      {!chapter && (
        <div className="not-found">
          <span>Chapter not found</span>
        </div>
      )}
      {chapter && (
        <>
          <h1>{chapter.title}</h1>

          <div
            ref={contentRef}
            className="chapterContent"
            dangerouslySetInnerHTML={{ __html: chapter.renderedContent || '' }}
          ></div>

          <ChapterNavigation
            book={book}
            prevChapter={prevChapter}
            nextChapter={nextChapter}
          />

          {chapter.renderedAuthorNote && (
            <section className="author_note">
              <h2>Author Note</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: chapter.renderedAuthorNote || '',
                }}
              ></div>
            </section>
          )}
        </>
      )}
    </div>
  );
};
